import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import Roles from '../../components/blocks/Roles';
import { getRoles } from '../../store/actions/roles';

export default function RoleContainer({ suppliersMenu = false }) {
  const { user } = useSelector((state) => state.role);
  const { retailers = [], suppliers = [], isSuperAdmin = false } = user ?? {};
  const hasNoRoles = useMemo(() => retailers.length === 0 && suppliers.length === 0, [retailers, suppliers]);

  useEffect(() => {
    if (hasNoRoles) {
      getRoles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isSuperAdmin && hasNoRoles) {
    return null;
  }

  return <Roles suppliersMenu={suppliersMenu} />;
}

Roles.propTypes = {
  suppliersMenu: PropTypes.bool,
};
